export default __webpack_public_path__ + "static/media/cai-design07.d9810b33.jpg";